import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import api from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";
import { canSeeTickets } from "../../lib/tickets";

// D-41: under the mission's title, « Ouverte depuis le ticket TKT-… » when the mission was created from a support ticket
// (« Demander une intervention sur place »). Only tickets the reader may see; nothing otherwise, never an error.
export default function MissionTicketOrigin({ missionId }) {
  const { user } = useAuth();
  const visible = canSeeTickets(user);
  const [tickets, setTickets] = useState([]);
  useEffect(() => {
    if (!visible) return undefined;
    let alive = true;
    api.get("/tickets", { params: { mission_id: missionId, limit: 20 } })
      .then(({ data }) => { if (alive) setTickets(data.items.filter((t) => t.opened_this_mission)); })
      .catch(() => {});
    return () => { alive = false; };
  }, [visible, missionId]);
  if (!tickets.length) return null;
  return (
    <p className="text-sm text-slate-600 inline-flex flex-wrap items-center gap-x-1.5" data-testid="mission-ticket-origin">
      <LifeBuoy size={14} className="text-slate-400" aria-hidden="true" />
      Ouverte depuis le ticket
      {tickets.map((t, i) => (
        <span key={t.id}>
          <Link to={`/support/tickets/${t.id}`} className="text-jamora hover:underline tabular-nums">{t.number}</Link>
          {i < tickets.length - 1 ? "," : ""}
        </span>
      ))}
    </p>
  );
}
